import React, { useEffect } from "react";

import "../Styles/Recipe.css";

import axios from "axios";


import { Link, useParams, useNavigate } from 'react-router-dom'
import { useState } from "react";

import Cookies from "js-cookie";

export default function Recipe(props) {
    const { id } = useParams();
    const [recipe, setRecipe] = useState({});
    const [loading, setLoading] = useState(true);
    const [editable, setEditable] = useState(false);
    const [liked, setLiked] = useState(false);
    const navigate = useNavigate();

    function getTextColor(backgroundColor) {
        var r = parseInt(backgroundColor.substr(0,2),16);
        var g = parseInt(backgroundColor.substr(2,2),16);
        var b = parseInt(backgroundColor.substr(4,2),16);
        var yiq = ((r*299)+(g*587)+(b*114))/1000;
        return (yiq >= 128) ? 'black' : 'white';
    }
    function like(){
        setLiked(!liked);
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/like.php?token=" + Cookies.get("token") + "&id=" + id)
        .then((response) => {
            if (response.data.status !== "success") {
                alert(response.data.data);
            }
        }
        )
        .catch((error) => {
            console.log(error);
        }
        )
    }


    useEffect(() => {
        axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-recipe.php?id=" + id)
        .then((response) => {
            if (response.data.status === "success") {
                setRecipe(response.data.data);
                setLoading(false);
                axios.get("https://anatole-sot.xyz/api/recettes-gibli/get-user.php?token=" + Cookies.get("token"))
                .then((response) => {
                    if (response.data.status === "success") {
                        if(response.data.data.user.username === recipe.Username){
                            setEditable(true);
                        }
                    }
                })
                .catch((error) => {
                    console.log(error);
                })
            } else {
                if (response.data.data === "Recipe not found") {
                    navigate("/404");
                }
            }
        })
        .catch((error) => {
            console.log(error);
        })
        if (Cookies.get("token")){
            axios.get("https://anatole-sot.xyz/api/recettes-gibli/liked.php?token=" + Cookies.get("token") + "&id=" + id)
            .then((response) => {
                if (response.data.status === "success") {
                    if(response.data.data ==="Liked"){
                        setLiked(true);
                    }
                } else {
                    alert(response.data.data);
                }
            }
            )
            .catch((error) => {
                console.log(error);
            }
            )
        }
    }, [id,navigate,recipe.Username]);

    if (loading) {
        return (
            <div className="Recipe">
                <h1>Chargement...</h1>
            </div>
        );
    }
    else{
        /* Sample recipe object:
        {
            "status": "success",
            "data": {
                "User_id": 1,
                "Username": "ano002",
                "Profile_pic": "https://anatole-sot.xyz/api/recettes-gibli/uploads/users/gradient.jpg",
                "Title": "Houmous",
                "Temps": 7,
                "personnes": 6,
                "Ingredients": [
                "(2 cuillères à soupe de tahineh si on veut)"
                ],
                "Steps": [
                    "saler, poivrer et saupoudrer de paprika avant de servir"
                ],
                "Tags": [
                {
                "Name": "OLD",
                "Color": "FF0000"
                }
                ],
                "Category_name": "Apéritifs",
                "Category_logo": "cocktail",
                "Images": [
                    "http://anatole-sot.xyz/api/recettes-gibli/uploads/recipes/sprite.png"
                ]
            }
        }
        */


        const Title = recipe.Title;
        const Temps = recipe.Temps;
        const Personnes = recipe.personnes;
        const Ingredients = recipe.Ingredients;
        const Steps = recipe.Steps;
        const Tags = recipe.Tags;
        const Category_name = recipe.Category_name;
        return (
            <div className="Recipe">
                <div className="RecipeHeader">
                    <h1>{Title}
                        {editable? <Link className="edit" to={"/edit/"+id}>✎</Link>:""}
                        {Cookies.get("token") ? 
                        <button className={liked ? "on" : "off"} onClick={like}>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke="#721817" >
                                <g id="SVGRepo_iconCarrier"> 
                                    <path d="M2 9.1371C2 14 6.01943 16.5914 8.96173 18.9109C10 19.7294 11 20.5 12 20.5C13 20.5 14 19.7294 15.0383 18.9109C17.9806 16.5914 22 14 22 9.1371C22 4.27416 16.4998 0.825464 12 5.50063C7.50016 0.825464 2 4.27416 2 9.1371Z" />
                                </g>
                            </svg>
                        </button> : ""}
                    </h1>
                </div>
                <div className="tags">
                    <div className="tag category">
                        {Category_name}
                    </div>
                    {Tags.map((tag,index) => {
                        return (
                            <div key={index} className="tag" style={{backgroundColor: "#" + tag.Color, color : getTextColor(tag.Color)}}>
                                {tag.Name}
                            </div>
                        );
                    })}
                </div>
                <div className="infos">
                    <div className="time">
                        {Temps} <span className="emoji">⏱</span>
                    </div>
                    <div className="people">
                        {Personnes} <span className="emoji">👤</span>
                    </div>
                    <Link to={"/user/"+recipe.User_id} className="author">
                        <img src={recipe.Profile_pic} alt={recipe.Username} className="profile_pic"/>
                        <span className="username">{recipe.Username}</span>
                    </Link>
                </div>
                <div className="ingredients">
                    <h2>Ingrédients</h2>
                    <ul>
                        {Ingredients.map((ingredient,index) => {
                            return (
                                <li key={index}>{ingredient}</li>
                            );
                        })}
                    </ul>
                </div>
                <div className="steps">
                    <h2>Étapes</h2>
                    <ol>
                        {Steps.map((step,index) => {
                            return (
                                <li key={index}>{step}</li>
                            );
                        })}
                    </ol>
                </div>
                <div className="images">
                    {recipe.Images.map((image, index) => {
                        
                        return (
                            image !== "" ? image.startsWith("data:video") ? 
                            <video key={index} src={image} alt="preview" controls></video>
                             : <img key={index} src={image} alt="preview"/> : null
                        );
                    })}
                </div>
            </div>
        );
    }
}
